import { render, staticRenderFns } from "./ViewForeignSchools.vue?vue&type=template&id=15cbb99c"
import script from "./ViewForeignSchools.vue?vue&type=script&lang=js"
export * from "./ViewForeignSchools.vue?vue&type=script&lang=js"
import style0 from "./ViewForeignSchools.vue?vue&type=style&index=0&id=15cbb99c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports